import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type { NodePartner } from '../../../types/uncinc_profile/nodes';

export default function nodePartnersWidgetMapper(partners: ReferenceField<NodePartner>[]): string[] {
  return partners.map((partner) => partner.entity.title[0].value);
}
